import { render, staticRenderFns } from "./NewCategoryScreen.vue?vue&type=template&id=06ee65ee&scoped=true&"
import script from "./NewCategoryScreen.vue?vue&type=script&lang=js&"
export * from "./NewCategoryScreen.vue?vue&type=script&lang=js&"
import style0 from "./NewCategoryScreen.vue?vue&type=style&index=0&id=06ee65ee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ee65ee",
  null
  
)

export default component.exports